export default __webpack_public_path__ + "static/profile-pic-3-450d9f48a4f2721d395870cab4b3726b.jpeg";